require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.iterator.js");

// const req1 = require.context('sk-web-framework/assets/images/svg_icons', false, /\.svg$/)
// const requireAll1 = requireContext => requireContext.keys().map(requireContext)
// requireAll1(req1)
var req = require.context('@/assets/images/svg_icons', false, /\.svg$/);

var requireAll = function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
};

requireAll(req);